// extracted by mini-css-extract-plugin
var _1 = "LinkForm_controls__83733";
var _2 = "LinkForm_input__1db75";
var _3 = "LinkForm_root__8b953";
export { _1 as "controls", _2 as "input", _3 as "root" }
